/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Club_Time_Zone_InvalidInputs */

const en_us2_club_time_zone_invalid = /** @type {(inputs: Club_Time_Zone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The device's time zone wasn't recognised.`)
};

const pt_br2_club_time_zone_invalid = /** @type {(inputs: Club_Time_Zone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O fuso horário do aparelho não foi reconhecido.`)
};

const es_419_club_time_zone_invalid = /** @type {(inputs: Club_Time_Zone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se reconoció la zona horaria del dispositivo.`)
};

const pt_pt2_club_time_zone_invalid = /** @type {(inputs: Club_Time_Zone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O fuso horário do dispositivo não foi reconhecido.`)
};

const fr_fr2_club_time_zone_invalid = /** @type {(inputs: Club_Time_Zone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le fuseau horaire de l'appareil n'a pas été reconnu.`)
};

const de_de2_club_time_zone_invalid = /** @type {(inputs: Club_Time_Zone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Zeitzone des Geräts wurde nicht erkannt.`)
};

const it_it2_club_time_zone_invalid = /** @type {(inputs: Club_Time_Zone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il fuso orario del dispositivo non è stato riconosciuto.`)
};

/**
* | output |
* | --- |
* | "The device's time zone wasn't recognised." |
*
* @param {Club_Time_Zone_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const club_time_zone_invalid = /** @type {((inputs?: Club_Time_Zone_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Club_Time_Zone_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_club_time_zone_invalid(inputs)
	if (locale === "es-419") return es_419_club_time_zone_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_club_time_zone_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_club_time_zone_invalid(inputs)
	if (locale === "de-DE") return de_de2_club_time_zone_invalid(inputs)
	if (locale === "it-IT") return it_it2_club_time_zone_invalid(inputs)
	return en_us2_club_time_zone_invalid(inputs)
});
export { club_time_zone_invalid as "club.time_zone_invalid" }